export default {
    props : {
        attachRoot : {type:Boolean, default: false},
        anchor : null
    },
    computed : {
        hasAnchor() {return !!this.anchor},
        posStyle() {
            var rect, rtn = {}, pos;
            if(!this.hasAnchor || !this.attachRoot) {
                var $origin = this.$parent.$el;
                rect = $origin.getBoundingClientRect();
                var x = rect.left, y=rect.top;
                var sx = document.body.clientWidth, sy = document.body.clientHeight;
                rtn[(x>sx/2)?'right':'left'] = '0';
                rtn[(y>sy/2)?'bottom':'top'] = '100%';
                return rtn;
            } else {
                // 0. Prepare process.
                // 0.1 check anchor & element
                var $anchor = this.anchor.$el || this.anchor;
                if(!$anchor) return {top:0};
                // 0.2 prepare position info.
                rect = $anchor.getBoundingClientRect();
                var scrWidth  = document.body.clientWidth;
                var scrHeight = document.body.clientHeight;
                // 0.3 It's flag
                var rightFlag = false, bottomFlag = false;
                
                // 1. calc position & type
                pos = {x:rect.left,y:rect.top+rect.height};
                if(rect.left > scrWidth/2) {
                    rightFlag = true;
                    pos.x = scrWidth - (pos.x + rect.width);
                }
                if(rect.top > scrHeight/2) {
                    bottomFlag = true;
                    pos.y = scrHeight - rect.top;
                }
                // 2. make style objct
                rtn[bottomFlag?'bottom':'top'] = pos.y+'px';
                rtn[rightFlag ?'right':'left'] = pos.x+'px';
                return rtn;
            }
        },
    },
    mounted() {
        if(this.hasAnchor && this.attachRoot) {
            this.$nextTick(()=> {
                var root = this.$root.$el;
                root.appendChild(this.$el);
            })
        }
    }
}